import * as constants from './constants'

export const updateAccount = details => ({
    type: constants.UPDATE_ACCOUNT,
    details,
})

export const deleteAccount = reason => ({
    type: constants.DELETE_ACCOUNT,
    reason,
})
